import React from "react";
import { images, journey } from "../data/content";
export function Journey() {
  return <section className="border-t border-paper-line py-24 md:py-36" data-id="element-182" data-mp="1iq7afhhlbx7e">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10" data-id="element-183" data-mp="1it1uv90lti0t">
        <h2 className="max-w-4xl text-[40px] font-semibold leading-[1] tracking-[-0.035em] md:text-[64px]" data-id="element-184" data-mp="1epwubc033qet">
          De votre premier appel à <span className="font-serif font-normal italic text-brand" data-id="element-185" data-mp="19sdfa9vkb9lt">votre première vente.</span>
        </h2>

        <ol className="mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-186" data-mp="22eoeph7fn4h1">
          {journey.map((step, i) => <li key={step.title} className="relative border-t-2 border-ink pt-6" data-id="element-187" data-mp="1xng2kdepx506" data-mpi={i}>
              <span className="font-serif text-[44px] italic leading-none text-brand" data-id="element-188" data-mp="1sowkio38wdd3">{i + 1}</span>
              <h3 className="mt-5 text-[22px] font-medium tracking-[-0.02em]" data-id="element-189" data-mp="2q40ks87gqwf4">{step.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-ink-muted" data-id="element-190" data-mp="2ldk8irfdpguc">{step.text}</p>
            </li>)}
        </ol>

        <figure className="relative mt-24" data-id="element-191" data-mp="2oxo66aqeca3q">
          <img src={images.event} alt="L'équipe dirigeante de SAFTI réunie sur scène pour les 10 ans du réseau" className="aspect-[21/9] w-full object-cover" data-id="element-192" data-mp="2oyps5a8yah08" />
          <figcaption className="mt-4 flex flex-wrap justify-between gap-2 text-[13px] text-ink-muted" data-id="element-193" data-mp="2g2i7rwtggub8">
            <span data-id="element-194" data-mp="2k3k1jy4lse5t">Convention SAFTI — les 10 ans du réseau</span>
            <span data-id="element-195" data-mp="264kaykxj5p70">Des événements toute l'année pour se retrouver</span>
          </figcaption>
        </figure>
      </div>
    </section>;
}